import {Dictionary} from 'lodash'
import {FC} from 'react'

import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {IncludedBenefit, IncludedBenefitType} from '../common/benefits/IncludedBenefit'
import {Text, TextVariant} from '../common/content/Text'

type ServiceRequestBenefitsProps = {
  title?: string
  subtitle?: string
  list: IncludedBenefitType[]
  variables?: Dictionary<any>
}

export const ServiceRequestBenefits: FC<React.PropsWithChildren<ServiceRequestBenefitsProps>> = ({
  title,
  subtitle,
  list,
  variables,
}) => {
  return (
    <>
      {title && (
        <div className="title">
          <Text variant={TextVariant.h2}>{title}</Text>
        </div>
      )}
      {subtitle && (
        <div className="subtitle">
          <Text color={theme.palette.text.light}>{subtitle}</Text>
        </div>
      )}
      <ul className="list">
        {list.map(({title, description}) => (
          <li key={title} className="item">
            <IncludedBenefit title={title} description={description} variables={variables} />
          </li>
        ))}
      </ul>

      <style jsx>{`
        .subtitle {
          margin-top: ${theme.spacing[6]};
          margin-bottom: -${theme.spacing[6]};
        }
        .list {
          margin-top: ${theme.spacing[8]};
        }
        .item {
          margin-top: ${theme.spacing[5]};
        }
        @media ${TABLET_SCREENSIZE} {
          .title {
            text-align: center;
          }
          .list {
            display: flex;
            flex-wrap: wrap;
            margin-top: ${theme.spacing[6]};
          }
          .item {
            flex: 1 0 46%;
            max-width: 46%;
          }
          .item:nth-child(even) {
            margin-left: ${theme.spacing[6]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .subtitle {
            margin-top: ${theme.spacing[5]};
            margin-bottom: -${theme.spacing[4]};
          }
          .list {
            margin-top: ${theme.spacing[4]};
          }
          .item {
            flex: 1 0 100%;
            max-width: inherit;
            margin-top: ${theme.spacing[4]};
          }
          .item:nth-child(even) {
            margin-left: 0;
          }
        }
      `}</style>
    </>
  )
}
